import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiBrowserCheckModule } from './browser-check/browser-check.module';
import { FiCountdownNotificationModule } from './countdown-notification/countdown-notification.module';
import { PlatformShutDownNotificationModule } from './platform-shut-down-notification/platform-shut-down-notification.module';
import { UpgradeMessageNotificationModule } from '@fi-app/utilities/notification/upgrade-message-notification/upgrade-message-notification.module';

@NgModule({
    imports: [
        CommonModule,
        FiBrowserCheckModule,
        FiCountdownNotificationModule,
        PlatformShutDownNotificationModule,
        UpgradeMessageNotificationModule,
    ],
    exports: [
        FiBrowserCheckModule,
        FiCountdownNotificationModule,
        PlatformShutDownNotificationModule,
        UpgradeMessageNotificationModule,
    ],
})
export class FiNotificationItemsModule {}
